/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personal_Program_Status_PausedInputs */

const fr_personal_program_status_paused = /** @type {(inputs: Personal_Program_Status_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En pause`)
};

/**

* @param {Personal_Program_Status_PausedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const personal_program_status_paused = /** @type {((inputs?: Personal_Program_Status_PausedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personal_Program_Status_PausedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_personal_program_status_paused(inputs)
});